import styled from 'styled-components';
import { Box, Text } from '@usealloy/component-library';


export const CardContainer = styled(Box)`
  border: solid 1px var(--cl-gray-500);
  border-radius: var(--cl-radius-4);
  padding: var(--cl-space-4);
`;

export const HeaderText = styled(Text)`
  && {
    color: var(--cl-gray-700);
    font-size: var(--cl-font-size-1);
    line-height: var(--cl-line-height-1);
  };
`;

export const DatePreview = styled.div`
  float: right;
  margin-bottom: var(--cl-space-4);
  color: var(--text-text-secondary-gray-700, #7A7972);
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1px;
`;

export const RuleBreakdownColumn = styled(Box)`
  && {
    align-items: flex-start;
    flex-direction: column;
  };
`;

export const RuleBreakdownValue = styled(Text)`
  && {
    color: var(--cl-gray-1100);
    font-size: var(--cl-font-size-2);
    line-height: var(--cl-line-height-2);
  };
`;

export const RuleSummaryText = styled(Text)`
  && {
    color: var(--cl-gray-1000);
    font-family: var(--cl-font-family-mono);
    font-size: var(--cl-font-size-1);
    line-height: var(--cl-line-height-1);
  };
`;
